import { FC } from 'react'
import { Typography, Box, Divider, Chip, Paper } from '@mui/material'
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'
import { Surgery } from '../types'

interface SurgeryCardProps {
  surgery: Surgery
}

const SurgeryCard: FC<SurgeryCardProps> = ({ surgery }) => {
  return (
    <Paper elevation={0} className="surgery-card">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Box>
          <Typography className="patient-name">
            {surgery.patient.name}
          </Typography>
          <Typography className="patient-info">
            MRN: {surgery.patient.id} | DOB: {surgery.patient.dateOfBirth}
          </Typography>
        </Box>
        <Box>
          <Chip
            icon={<MeetingRoomIcon />}
            label={surgery.room}
            size="small"
            color="primary"
            variant="outlined"
            className="room-chip"
          />
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box className="surgery-details">
        <Typography variant="body2" className="surgery-surgeon">
          <strong>Surgeon:</strong> {surgery.surgeon}
        </Typography>
        <Typography variant="body2" className="surgery-procedures">
          <strong>Procedures:</strong> {surgery.procedures.join(', ')}
        </Typography>
      </Box>
    </Paper>
  )
}

export default SurgeryCard
